export const CHANNELS = {
  baseProxySwitch: 'baseProxySwitch',
};
